exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-container[data-v-7bec9415]{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7bec9415","scoped":true,"hasInlineConfig":false}!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/js/vue-components/conference-agenda/ConfAgendaSession.vue
// module id = 126
// module chunks = 0